<template>
  <a-modal :width="400" v-model="visible" :destroyOnClose="true" @ok="handleOk">
    <a-form
      :form="form"
      @submit="handleSubmit"
      style="width: 70%;margin: 0 auto"
    >
      <a-form-item v-if="table === 1" style="text-align: center">
        <img class="imgeTie" src="./image/ok.png" />
        <br />
        <span>上传凭证成功</span>
        <p>
          上传付款完成,稍后我们客服会进行审核您的付款凭证,请静候佳音。谢谢您的合作！根据您的情况点击下面的按钮。
        </p>
      </a-form-item>
      <!--    <a-form-item v-if="table === 2" style="text-align: center">
        <img class="imgeTie" src="./image/timgTow.jpg" />
        <br />
        <span>抱歉，付款失败</span>
        <p>
          请稍后再试或联系客服：
        </p>
        <P>400-100-0000</P>
      </a-form-item>-->
    </a-form>
    <template slot="footer">
      <a-button
        slot="action"
        style="background: #FF8D1A;border: 1px solid #FF8D1A;"
        type="primary"
        @click="handPush"
        >返回</a-button
      >
      <!--      <a-button
        slot="action"
        type="primary"
        @click="
          () => {
            this.table = 2;
          }
        "
        >付款遇到问题</a-button
      >-->
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'proofModel',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      table: 1,
      //1-套餐，2-订单
      dowtype: '',
    };
  },
  created() {
    // 获取页面路径信息
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
      // return theRequest;
    }
    // 类型 1-套餐，2-订单
    this.dowtype = theRequest.type;
  },
  methods: {
    init(value) {
      console.log('===弹框==', value);
      this.table = 1;
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
    handPush() {
      this.table = 1;
      if (this.dowtype === '1') {
        this.$router.push({
          path: '/mySetMeal',
        });
      } else {
        this.$router.push({
          path: '/allorder',
        });
      }
    },
    // 邮箱
    handleSubmit(e) {
      console.log(e);
      event.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('=====数据====', values);
        }
      });
    },
  },
};
</script>

<style scoped>
.imgeTie {
  width: 60px;
}
</style>
